<template>
    <div v-if="workspaces.length > 1" class="workspace-select">
        <CustomSelect
            v-model="activeWorkspace"
            :options="workspaces"
            :form-value-text="(item) => item.name"
            view-label="name"
            emit-prop="id"
            class="workspace-select__select"
            with-filter
        >
            <template #content-append>
                <WithGlobalPermission permission="Customer.create">
                    <router-link
                        :to="{ name: 'customers-create' }"
                        class="button workspace-select__create-customer"
                    >
                        Add new Customer
                    </router-link>
                </WithGlobalPermission>
            </template>
        </CustomSelect>
        <Spinner v-if="loading" />
    </div>
</template>

<script>
import { CustomSelect } from '@speechki-frontend/shared/ui/forms';
import Spinner from '@speechki-frontend/shared/ui/Spinner';

import { mapActions, mapState } from 'vuex';
import { WithGlobalPermission } from '@speechki-frontend/core/auth/components';

export default {
    name: 'WorkspaceSelect',
    components: {
        CustomSelect,
        Spinner,
        WithGlobalPermission,
    },

    computed: {
        ...mapState('workspaces', {
            workspaces: (state) => state.workspaces,
            loading: (state) => state.loading,
        }),

        activeWorkspace: {
            get() {
                return (
                    this.$store.state.workspaces.activeWorkspace &&
                    this.$store.state.workspaces.activeWorkspace.id
                );
            },
            set(value) {
                this.setActiveWorkspace(value);
            },
        },
    },
    watch: {
        activeWorkspace(id) {
            const customerRoutes = [
                'customers-id-statistic',
                'customers-id-stylesheet',
                'customers-id-default-speakers',
            ];
            if (customerRoutes.includes(this.$route.name)) {
                this.$router.replace({
                    params: { id },
                });
            }
            if (id === 'inner' || this.$route.name !== 'customers-id') return;
            this.$router.push({
                name: 'customers-id',
                params: { id },
            });
        },
    },
    methods: {
        ...mapActions('workspaces', ['setActiveWorkspace']),
    },
};
</script>

<style lang="scss" src="./WorkspaceSelect.scss"></style>
